import flagsmith from '@flagsmith/flagsmith';
import { FlagsmithProvider as SdkFlagsmithProvider } from '@flagsmith/flagsmith/react';
import React, { type FC, type PropsWithChildren } from 'react';
import { createFeatureFlagsOptions } from './feature-flags.config';

const options = createFeatureFlagsOptions(
  process.env.VITE_APP_FLAGSMITH_ENVIRONMENT_KEY,
);

export const FeatureFlagsProvider: FC<PropsWithChildren> = ({ children }) => (
  <SdkFlagsmithProvider flagsmith={flagsmith} options={options}>
    {children}
  </SdkFlagsmithProvider>
);
